import React, { useEffect } from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { useParams, useLocation } from "react-router-dom"
import { useIntl } from "react-intl"
import { getLocale } from "locale.js"

import useService from "hooks/useService"
import useSystem from "hooks/useSystem"

import AgreementCardList from "organisms/AgreementCardList"
import AgreementCardTitle from "organisms/AgreementCardTitle"
import DefaultContainer from "template/DefaultContainer"
import Loading from "molecules/Loading"
import BackButton from "molecules/BackButton"

const useStyles = makeStyles(theme => ({
  backButton: {
    paddingTop: "100px",
    paddingBottom: "100px",
    textAlign: "center",
  },
}))

const setLocaleServiceName = service => {
  if ("en" === getLocale()) {
    // サービスに英語名[nameEn]が設定されていない場合はデフォルトとして日本語名[name]を表示
    return service.nameEn ? service.nameEn : service.name
  } else {
    // サービスに日本語名[name]が設定されていない場合は英語名[nameEn]を表示
    return service.name ? service.name : service.nameEn
  }
}

const ServiceAgreement = () => {
  const classes = useStyles()
  const { id } = useParams()
  const { service, getServiceDetail } = useService()
  const { apiLoading } = useSystem()
  const modeValue = useLocation().search.slice(6)
  const intl = useIntl()
  const serviceName = setLocaleServiceName(service)

  const clickBackButtonParam = {
    mode: modeValue,
    title: intl.formatMessage({ id: "ServiceAgreement.BackButtonTitle" }),
  }

  useEffect(() => {
    getServiceDetail(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    document.title =
      apiLoading || !service
        ? intl.formatMessage({ id: "ServiceAgreement.DocumentTitle" })
        : `${serviceName}  | ${intl.formatMessage({
            id: "ServiceAgreement.DocumentTitle",
          })}`
    if (service.name) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "AgreementCard-Pageview",
        pagePath: "/" + id,
        pageTitle: document.title,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service])

  if (apiLoading) {
    return (
      <DefaultContainer>
        <Loading />
      </DefaultContainer>
    )
  }

  return (
    <DefaultContainer>
      <AgreementCardTitle name={serviceName} />
      <AgreementCardList toses={service.toses} />
      <Grid container direction="column" alignItems="center">
        <Grid item className={classes.backButton}>
          {modeValue === "none" ? (
            <></>
          ) : (
            <BackButton {...clickBackButtonParam} />
          )}
        </Grid>
      </Grid>
    </DefaultContainer>
  )
}

export default ServiceAgreement
